<script>
    import { onMount } from "svelte";
    
    export let label = "Datum";
    export let name;
    export let value;           // 01.01.2023
    let internal_value;         // 01.01.2023 or incomplete (01.01.) or invalid inputs (234) 
    let input;
    let valid;

    const placeholder = "z.B. 01.01.2023";
    const maxlength="10"
    const autocomplete = "off";
    const inputmode="text"
    let pattern = "^[0-3][0-9].[0-1][0-9].[0-9][0-9][0-9][0-9]$";

    onMount(() => {
        internal_value = value ?? undefined;
        valid = value ? true : undefined;
    })

    const now = new Date();
    const current_year = now.getFullYear().toString();

    function formatDate () {
        let allowedInputs = /^[0-9]$/;
        if (internal_value.length == 2 || internal_value.length == 3 || internal_value.length == 5 || internal_value.length == 6) {
            allowedInputs = /^[0-9]|\.$/;
        }
        if (!allowedInputs.test(internal_value[internal_value.length-1]) && internal_value.length > 0) {
            internal_value = internal_value.slice(0, -1);
        }
        switch(internal_value.length) {
            case 1:
                if (parseInt(internal_value[0]) > 3) {
                    internal_value = "0" + internal_value[0] + ".";
                }
                break;
            case 2:
                if (parseInt(internal_value[0]+internal_value[1]) > 31) {
                    // Since the only values higher than 32 have a "2" as a second digit,
                    // the "2" can't be the first digit of a month and therefore must be a full month
                    internal_value = "0" + internal_value[0] + ".0" + internal_value[1] + ".";
                }
                // 1. => 01.
                if (internal_value[1] == ".") {
                    internal_value = "0" + internal_value[0] + ".";
                }
                break;
            case 3:
                if (internal_value[2] != ".") {
                    if (internal_value[2] > 1) {
                        internal_value = internal_value[0] + internal_value[1] + ".0" + internal_value[2] + ".";
                    } else {
                        internal_value = internal_value[0] + internal_value[1] + "." + internal_value[2];
                    }
                }
                break;
            case 4:
                if (parseInt(internal_value[3]) > 1) {
                    internal_value = internal_value[0] + internal_value[1] + internal_value[2] + "0" + internal_value[3] + ".";
                }
                break;
            case 5:
                // 01.2. => 01.02.
                if (internal_value[4] == ".") {
                    internal_value = internal_value[0] + internal_value[1] + internal_value[2] + "0" + internal_value[3] + ".";
                }
                break;
            case 6:
                if (internal_value[5] != ".") {
                    internal_value = internal_value[0] + internal_value[1] + internal_value[2] + internal_value[3] + internal_value[4] + "." + internal_value[5];
                }
                break;
        }
    }

    function finalizeDate () {
        if (!internal_value) {
            value = undefined;
            valid = false;
            return
        }

        // 20.02 => 20.02.2023
        if (internal_value.match("^[0-3][0-9].[0-1][0-9]$")) {
            internal_value = internal_value + "." + current_year;
        }

        // 20.02. => 20.02.2023
        else if (internal_value.match("^[0-3][0-9].[0-1][0-9].$")) {
            internal_value = internal_value + current_year;
        }
        
        // 20.02.3 => 20.02.2003
        else if (internal_value.match("^[0-3][0-9].[0-1][0-9].[0-9]$")) {
            internal_value = internal_value.slice(0, 6) + current_year.slice(0, 2) + "0" + internal_value.slice(6, 7);
        }

        // 20.02.23 => 20.02.2023
        else if (internal_value.match("^[0-3][0-9].[0-1][0-9].[0-9][0-9]$")) {
            internal_value = internal_value.slice(0, 6) + current_year.slice(0, 2) + internal_value.slice(6, 8);
        }

        // 20.02.123 => 20.02.2123
        else if (internal_value.match("^[0-3][0-9].[0-1][0-9].[0-9][0-9][0-9]$")) {
            internal_value = internal_value.slice(0, 6) + current_year.slice(0, 1) + internal_value.slice(6, 9);
        }

        else if (!internal_value.match(pattern)) {
            value = undefined;
            valid = false
            return
        }
        value = internal_value;
        valid = true;
        return
    }

    function selectAll() {
        input.setSelectionRange(0, internal_value?internal_value.length:0);
    }
</script>


<label>
    <span class="label">
        {label}
    </span>
    <input
        type="text"
        bind:value={internal_value}
        bind:this={input}
        on:click={selectAll}
        on:input={formatDate}
        on:blur={finalizeDate}
        class:invalid={valid === false}
        {name}
        {placeholder}
        {maxlength}
        {autocomplete}
        {inputmode}
        {pattern}
    >
</label>


<style>
    label {
        margin-bottom: 1rem;
    }

    .label {
        display: block;
        margin-bottom: 0.2rem;
        font-size: 0.8rem;
    }

    input {
        display: block;
        border-radius: 0.5rem;
        border: 2px solid #F5F2EF;
    }

    .invalid:not(:focus-within) {
        animation: shake 0.4s linear;
    }

    @keyframes shake {
        0% {
            transform: translateX(-10px);
            border-color: #DA4A2B;
        }
        25% {
            transform: translateX(9px);
        }
        50% {
            transform: translateX(-4px);
        }
        75% {
            transform: translateX(2px);
        }
        100% {
            transform: translateX(0px);
        }
    }
</style>

